/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'
import _forEach from 'lodash/forEach'
import {getOwnBetInfos, getDefaultBet} from './constant'
import {HomePageType} from '../components/King/reducers'
import type {JackpotInfoType} from './components/Jackpot'

// 主接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151078858
export const rocket_homepage = createAsyncThunk(
  '/live/ground/rt_homepage',
  async (arg, store) => {
    const resp = await http.post(
      '/live/ground/rt_homepage',
      {},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 下注接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151078862
export const rocket_bet = createAsyncThunk(
  '/live/ground/rt_bet',
  async (
    arg: {
      pos_id: 1 | 2
      bet_coins: number
      bet_odds: number
      h_web_room_id: number
      source?: string
    },
    store
  ) => {
    const resp = await http.post(
      '/live/ground/rt_bet',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 申请跳机 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151078862
export const rocket_jump = createAsyncThunk(
  '/live/ground/rt_jump',
  async (
    arg: {
      pos_id: 1 | 2
      jump_odds: number
    },
    store
  ) => {
    const resp = await http.post(
      '/live/ground/rt_jump',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 查询历史结果接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151078867
export const rocket_result = createAsyncThunk(
  '/live/ground/rt_result',
  async (arg: {round_no: string}, store) => {
    const resp = await http.post(
      '/live/ground/rt_result',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 设置表情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151078873
export const rocket_set_emoji = createAsyncThunk(
  '/live/ground/rt_set_emoji',
  async (arg: {emoji_id: number}, store) => {
    const resp = await http.post(
      '/live/ground/rt_set_emoji',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}

export enum GameStatus {
  bet = 0,
  fly = 1,
  boom = 2,
}

export enum BtnStatusEnum {
  bet = 0,
  betGrey = 1,
  jump = 2,
  jumpGrey = 3,
}

interface memberInfo {
  id: number
  name: string
  zy_id: string
  avatar: string
}

export interface betInfo {
  pos_id?: 1 | 2 // 1左 2右
  default_bet_odds?: number // 推荐下注倍率
  default_bet_coins?: number // 推荐下注金额
  bet_odds?: number // 自动跳机倍率
  bet_coins?: number // 下注金额
  jump_odds?: number // 实际跳机倍率
  reward_coins?: number // 奖励金币
  cur_bet_coins?: number // 当前下注金额
  cur_bet_odds?: string | number // 当前下注倍率 优先取 实际跳机倍率 在取 自动跳机倍率 后取 推荐下注倍率 对应的下标
  need_jump?: boolean // 需要展示跳机动画
}

export enum BtnOptionEnum {
  down = -1,
  up = 1,
}
export enum BtnTypeEnum {
  倍率 = 1,
  金币 = 2,
}
interface resultInfo {
  round_no: number // 轮次id
  crash_odds: number // 爆炸倍率
}

export interface betRankInfo extends memberInfo {
  pos_id: number
  bet_coins: number
  jump_odds: number
  emoji: string
  time?: string // 时间标记
}

interface InitialStateType {
  base?: {
    hasPreLoadedAct?: boolean // 前置加载引导标志
    isLoading?: boolean // 加载标志
    playMusic?: boolean // 播放音乐
    longTime?: any // 长链接及主接口上次更新时间
    fresh?: boolean // 刷新主流程
    first?: boolean // 第一次进入后的接口成功
    hideRocket?: boolean
  }
  home?: {
    bet_odds_options?: Array<number> // 下注赔率选项
    bet_coins_options?: Array<number> // 下注金额选项
    emojis?: Array<{
      emoji_id: number
      icon: string
    }> // 表情
    emoji_count_down?: number
    fly_timeline?: Array<number> // 时间轴，每隔0.1秒对应的赔率
    top_users?: Array<betRankInfo> // 下注额前9名
    coin_num?: number // 当前用户余额
    today_win?: number // 用户当日赢取总金额
    own?: memberInfo // 用户个人信息
    own_bet_info?: [betInfo, betInfo] // 左右下注位
    own_round_bet?: number // 自己本轮下注总额
    own_round_reward?: number // 自己本轮奖励总额
    history_results?: Array<resultInfo> // 最近18局结果
    today_highest?: resultInfo // 今日最高赔率
    round_no?: number // 轮次ID
    day_round?: number // 当日轮次
    round_status?: GameStatus // 0:下注阶段; 1:飞行中阶段; 2:爆炸后阶段
    status_expire?: number // 前端 > 0 服务端 逻辑 -1:不定期限; >=0:状态倒计时（单位：秒）
    cur_status_expire?: number // 长链接实时倒计时
    crash_odds?: number // 爆炸后：爆炸倍率
    fly_time_offset?: number // 飞行中：飞行时间轴偏移量
    jump_useInfo?: {
      jump_users?: Array<{
        id: number
        avatar: string
      }> // 跳机用户（可选）
      time: any
    }
    others?: {
      emoji?: string // 未上榜用户表情队列
      time?: any // 时间
    }
    top_bet?: {
      time?: any // 时间
      top_new_bet?: boolean // 上榜用户有新下注（可触发动画）
    }
    other_bet?: {
      time?: any // 时间
      other_new_bet?: boolean // 上榜用户有新下注（可触发动画）
    }
    new_time?: any // 最新的请求或者长链接时间  用于飞行期间的状态请求
    bet_mids?: Array<number> // 本次长链接下注所有人
    rocket_king_status_info?: Pick<
      HomePageType,
      'status' | 'jackpot_val' | 'start_progress' | 'settle_done'
    >
    rocket_jackpot_status_info?: Pick<
      JackpotInfoType,
      'jackpot_val' | 'status'
    > & {
      settle_done: boolean // 当前round_no是否结算完成（true/false）
    }
  }
}
const initialState: InitialStateType = {}

const initData: InitialStateType = {
  base: {
    hasPreLoadedAct: false,
    isLoading: true,
    playMusic: true,
    longTime: null,
    hideRocket: false,
  },
  home: {
    own_bet_info: [{}, {}],
    fly_timeline: [
      1, 1, 1.01, 1.02, 1.03, 1.04, 1.05, 1.06, 1.07, 1.08, 1.09, 1.1, 1.11,
      1.12, 1.13, 1.14, 1.15, 1.16, 1.17, 1.18, 1.19, 1.2, 1.21, 1.22, 1.24,
      1.25, 1.26, 1.27, 1.28, 1.29, 1.3, 1.32, 1.33, 1.34, 1.35, 1.37, 1.38,
      1.39, 1.4, 1.42, 1.43, 1.44, 1.45, 1.47, 1.48, 1.49, 1.51, 1.52, 1.54,
      1.55, 1.56, 1.58, 1.59, 1.61, 1.62, 1.64, 1.65, 1.67, 1.68, 1.7, 1.71,
      1.73, 1.74, 1.76, 1.77, 1.79, 1.81, 1.82, 1.84, 1.86, 1.87, 1.89, 1.91,
      1.92, 1.94, 1.96, 1.98, 1.99, 2.01, 2.03, 2.05, 2.07, 2.09, 2.11, 2.12,
      2.14, 2.16, 2.18, 2.2, 2.22, 2.24, 2.26, 2.28, 2.3, 2.33, 2.35, 2.37,
      2.39, 2.41, 2.43, 2.45, 2.48, 2.5, 2.52, 2.54, 2.57, 2.59, 2.61, 2.64,
      2.66, 2.69, 2.71, 2.74, 2.76, 2.78, 2.81, 2.84, 2.86, 2.89, 2.91, 2.94,
      2.97, 2.99, 3.02, 3.05, 3.08, 3.1, 3.13, 3.16, 3.19, 3.22, 3.25, 3.28,
      3.31, 3.34, 3.37, 3.4, 3.43, 3.46, 3.49, 3.52, 3.55, 3.58, 3.62, 3.65,
      3.68, 3.72, 3.75, 3.78, 3.82, 3.85, 3.89, 3.92, 3.96, 3.99, 4.03, 4.07,
      4.1, 4.14, 4.18, 4.22, 4.25, 4.29, 4.33, 4.37, 4.41, 4.45, 4.49, 4.53,
      4.57, 4.61, 4.65, 4.7, 4.74, 4.78, 4.83, 4.87, 4.91, 4.96, 5, 5.05, 5.09,
      5.14, 5.19, 5.23, 5.28, 5.33, 5.38, 5.43, 5.47, 5.52, 5.57, 5.62, 5.68,
      5.73, 5.78, 5.83, 5.88, 5.94, 5.99, 6.04, 6.1, 6.15, 6.21, 6.27, 6.32,
      6.38, 6.44, 6.5, 6.56, 6.61, 6.67, 6.73, 6.8, 6.86, 6.92, 6.98, 7.04,
      7.11, 7.17, 7.24, 7.3, 7.37, 7.44, 7.5, 7.57, 7.64, 7.71, 7.78, 7.85,
      7.92, 7.99, 8.06, 8.14, 8.21, 8.28, 8.36, 8.44, 8.51, 8.59, 8.67, 8.74,
      8.82, 8.9, 8.98, 9.07, 9.15, 9.23, 9.31, 9.4, 9.48, 9.57, 9.66, 9.74,
      9.83, 9.92, 10.01, 10.1, 10.19, 10.28, 10.38, 10.47, 10.56, 10.66, 10.76,
      10.85, 10.95, 11.05, 11.15, 11.25, 11.35, 11.46, 11.56, 11.66, 11.77,
      11.88, 11.98, 12.09, 12.2, 12.31, 12.42, 12.54, 12.65, 12.76, 12.88, 13,
      13.11, 13.23, 13.35, 13.47, 13.59, 13.72, 13.84, 13.97, 14.09, 14.22,
      14.35, 14.48, 14.61, 14.74, 14.87, 15.01, 15.14, 15.28, 15.42, 15.56,
      15.7, 15.84, 15.99, 16.13, 16.28, 16.42, 16.57, 16.72, 16.87, 17.03,
      17.18, 17.33, 17.49, 17.65, 17.81, 17.97, 18.13, 18.3, 18.46, 18.63, 18.8,
      18.97, 19.14, 19.31, 19.49, 19.66, 19.84, 20.02, 20.2, 20.38, 20.57,
      20.75, 20.94, 21.13, 21.32, 21.52, 21.71, 21.91, 22.1, 22.3, 22.51, 22.71,
      22.91, 23.12, 23.33, 23.54, 23.75, 23.97, 24.19, 24.41, 24.63, 24.85,
      25.07, 25.3, 25.53, 25.76, 25.99, 26.23, 26.46, 26.7, 26.95, 27.19, 27.43,
      27.68, 27.93, 28.19, 28.44, 28.7, 28.96, 29.22, 29.48, 29.75, 30.02,
      30.29, 30.56, 30.84, 31.12, 31.4, 31.68, 31.97, 32.26, 32.55, 32.85,
      33.14, 33.44, 33.75, 34.05, 34.36, 34.67, 34.98, 35.3, 35.62, 35.94,
      36.27, 36.59, 36.92, 37.26, 37.59, 37.93, 38.28, 38.62, 38.97, 39.33,
      39.68, 40.04, 40.4, 40.77, 41.14, 41.51, 41.88, 42.26, 42.64, 43.03,
      43.42, 43.81, 44.21, 44.61, 45.01, 45.42, 45.83, 46.24, 46.66, 47.08,
      47.51, 47.94, 48.37, 48.81, 49.25, 49.69, 50.14, 50.6, 51.05, 51.52,
      51.98, 52.45, 52.93, 53.41, 53.89, 54.38, 54.87, 55.36, 55.86, 56.37,
      56.88, 57.39, 57.91, 58.43, 58.96, 59.5, 60.03, 60.58, 61.12, 61.68,
      62.24, 62.8, 63.37, 63.94, 64.52, 65.1, 65.69, 66.28, 66.88, 67.49, 68.1,
      68.71, 69.33, 69.96, 70.59, 71.23, 71.88, 72.52, 73.18, 73.84, 74.51,
      75.18, 75.86, 76.55, 77.24, 77.94, 78.64, 79.36, 80.07, 80.8, 81.53,
      82.26, 83.01, 83.76, 84.52, 85.28, 86.05, 86.83, 87.61, 88.41, 89.21,
      90.01, 90.83, 91.65, 92.48, 93.31, 94.16, 95.01, 95.87, 96.73, 97.61,
      98.49, 99.38, 100,
    ],
    bet_coins_options: [
      100, 200, 400, 800, 1000, 2000, 4000, 6000, 8000, 10000, 20000, 40000,
      60000, 80000, 100000,
    ],
  },
}

export const GreedyRocketSlice = createSlice({
  name: 'GreedyRocket',
  initialState,
  reducers: {
    finishedLoading: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isLoading: false,
        },
      })
    },
    finishedPreLoadedAct: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          hasPreLoadedAct: true,
        },
      })
    },
    changePlayMusic: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          playMusic: !base.playMusic,
        },
      })
    },
    // 长链接-更新轮次变化
    updateRound: (state, action: PayloadAction<any>) => {
      const curUserInfo = state?.home?.jump_useInfo
      const {
        round_no,
        day_round,
        round_status,
        status_expire,
        fly_time_offset,
        crash_odds,
        jump_users,
        bet_rank_info,
        rocket_king_status_info,
        rocket_jackpot_status_info,
      } = action.payload
      const {top_users, others_emoji, top_new_bet, other_new_bet, bet_mids} =
        bet_rank_info || {}
      const userInfo =
        jump_users && jump_users?.length > 0
          ? {
              jump_users,
              time: Date.now(),
            }
          : curUserInfo

      let time = state.home.status_expire
      // 当前回合
      if (day_round === state.home?.day_round) {
        if (round_status !== state?.home.round_status) {
          // 非当前状态改变时间
          if (status_expire === -1) {
            time = 0
          } else {
            time = status_expire
          }
        }
      } else {
        // 非当前回合改变时间
        time = status_expire
      }
      Object.assign(state.home, {
        round_no,
        day_round,
        round_status,
        status_expire: time,
        cur_status_expire: status_expire,
        fly_time_offset,
        crash_odds,
        jump_useInfo: userInfo,
        new_time: Date.now(),
        top_users: top_users?.map((ite) => {
          return {...ite, time: Date.now()}
        }),
        others: {
          emoji: others_emoji,
          time: Date.now(),
        },
        top_bet: {
          top_new_bet,
          time: Date.now(),
        },
        other_bet: {
          other_new_bet,
          time: Date.now(),
        },
        bet_mids,
        rocket_king_status_info,
        rocket_jackpot_status_info,
      })
    },
    // 更新个人下注
    updateBetInfo: (state, action: PayloadAction<any>) => {
      const {own_bet_info} = action.payload
      Object.assign(state.home, {
        own_bet_info,
      })
    },
    updateFresh: (state) => {
      Object.assign(state.base, {
        fresh: !state.base?.fresh,
      })
    },
    updateCoins: (state, action: PayloadAction<betInfo>) => {
      const myBet = action.payload
      Object.assign(state.home, {
        coin_num: state.home.coin_num + myBet.bet_coins * myBet.jump_odds,
      })
    },
    updateFirst: (state) => {
      Object.assign(state.base, {
        first: true,
      })
    },
    hideRocket: (state) => {
      Object.assign(state.base, {
        hideRocket: true,
      })
    },
    showRocket: (state) => {
      Object.assign(state.base, {
        hideRocket: false,
      })
    },
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    // 首页信息
    builder.addCase(rocket_homepage.fulfilled, (state, action) => {
      // 需要设置当前的下注金币和下注倍率
      const {isLoading} = state.base
      const {own_bet_info, top_users, status_expire} = action.payload
      // isLoading 代表第一次请求
      const cur_bet_info = getOwnBetInfos(own_bet_info)
      Object.assign(state, {
        home: {
          ...action.payload,
          top_users: top_users?.map((ite) => {
            return {...ite, time: Date.now()}
          }),
          status_expire: status_expire === -1 ? 0 : status_expire,
          own_bet_info: cur_bet_info,
          time: Date.now(),
        },
      })
    })
    // 下注导致用户信息变化
    builder.addCase(rocket_bet.fulfilled, (state, action) => {
      // 需要设置当前的下注金币和下注倍率
      const {own_bet_info, top_users, status_expire, status} = action.payload
      // 下注成功更新数据
      if (status === 1) {
        const cur_bet_info = getOwnBetInfos(own_bet_info)
        Object.assign(state, {
          home: {
            ...state.home,
            ...action.payload,
            top_users: top_users?.map((ite) => {
              return {...ite, time: Date.now()}
            }),
            status_expire: status_expire === -1 ? 0 : status_expire,
            own_bet_info: cur_bet_info,
            time: Date.now(),
          },
        })
      }
    })
    // 跳机导致用户信息变化
    builder.addCase(rocket_jump.fulfilled, (state, action) => {
      // 需要设置当前的下注金币和下注倍率
      const {
        own_round_reward,
        round_status,
        status_expire,
        crash_odds,
        fly_time_offset,
        own_bet_info,
        status,
      } = action.payload
      // 下注成功更新数据
      // 1成功，2时钟错误，3已爆炸
      if (status === 1) {
        const cur_bet_info = getOwnBetInfos(own_bet_info)
        Object.assign(state, {
          home: {
            ...state.home,
            ...action.payload,
            own_round_reward,
            round_status,
            status_expire: status_expire === -1 ? 0 : status_expire,
            crash_odds,
            fly_time_offset,
            own_bet_info: cur_bet_info,
            time: Date.now(),
          },
        })
      }
    })
  },
})
export default GreedyRocketSlice.reducer
export const useGreedyRocketState = () => {
  return useSelector((state) => state.Animal_Albatross)
}
export const GreedyRocketActions = GreedyRocketSlice.actions
